var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageGallery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.388,
    height: 34.273,
    viewBox: "0 0 37.388 34.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-gallery",
    transform: "translate(-0.001 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0.001 6.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(0 6.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M9.736,25.4a5.833,5.833,0,0,1-5.518-3.974l-.055-.179a5.683,5.683,0,0,1-.27-1.689V8.932L.115,21.548A3.538,3.538,0,0,0,2.6,25.84l24.089,6.451a3.573,3.573,0,0,0,.9.115,3.473,3.473,0,0,0,3.367-2.547l1.4-4.463Z",
    transform: "translate(-0.001 -8.932)",
    fill: "#4397d2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M10.116,11.231A3.116,3.116,0,1,0,7,8.116,3.119,3.119,0,0,0,10.116,11.231Z",
    transform: "translate(3.904 -5)",
    fill: "#4397d2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M31.263,2H7.895A3.9,3.9,0,0,0,4,5.895V23.031a3.9,3.9,0,0,0,3.895,3.895H31.263a3.9,3.9,0,0,0,3.895-3.895V5.895A3.9,3.9,0,0,0,31.263,2ZM7.895,5.116H31.263a.779.779,0,0,1,.779.779V16.954L27.12,11.212a2.79,2.79,0,0,0-2.089-.958,2.724,2.724,0,0,0-2.081.983l-5.786,6.945L15.279,16.3a2.734,2.734,0,0,0-3.864,0l-4.3,4.3V5.895a.779.779,0,0,1,.779-.779Z",
    transform: "translate(2.231)",
    fill: "#4397d2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageGallery);
export default __webpack_public_path__ + "static/media/image-gallery.ad563442b523beccda9179db18ef2759.svg";
export { ForwardRef as ReactComponent };